import { Map } from '../common.type';
import styled from 'styled-components';

const Wrapper = styled.button<{ $mapId: number; $selected: boolean }>`
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column-reverse;
  border: 0;
  border-radius: ${(props) => `0.5${props.theme.unit}`};
  width: ${(props) => `20${props.theme.unit}`};
  height: ${(props) => `30${props.theme.unit}`};
  background: ${(props) =>
    `url(${process.env.PUBLIC_URL}/images/maps/${props.$mapId.toString()}.webp) no-repeat rgba(0,${props.$selected ? '255' : '0'},0,${props.$selected ? '0.5' : '0.3'})`};
  background-size: contain;
  padding: 0;

  & :disabled {
    cursor: default;
  }

  &:hover:not(:disabled) {
    background-color: rgba(0, 255, 0, 0.5);
  }
`;
const Name = styled.div`
  width: 100%;
  color: #fff;
  text-align: center;
  font-size: ${(props) => `3${props.theme.unit}`};
  padding: ${(props) => `1${props.theme.unit} 0.5${props.theme.unit}`};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: rgba(0, 0, 0, 0.2);
  text-shadow: ${(props) => `0 0.5${props.theme.unit} #000`};
  -webkit-text-stroke: ${(props) => `0.04${props.theme.unit} #000`};
`;

export const MapImg = ({
  map,
  selected,
  onClick,
}: {
  map: Map;
  selected: boolean;
  onClick?: (id: number) => void;
}) => {
  return (
    <Wrapper
      onClick={() => {
        if (onClick) onClick(map.id);
      }}
      $mapId={map.id}
      $selected={selected}
      disabled={!onClick}
      aria-disabled={!onClick}
      id={`map-${map.id.toString()}`}
    >
      <Name>{map.name}</Name>
    </Wrapper>
  );
};
